import SimpleModalDialog from './SimpleModalDialog.tsx'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../app/ReduxStore.ts'
import { hideGlobalModal } from '../../features/GlobalNotificationModalSlice.ts'

export default function GlobalNotificationModal() {
  const dispatch = useDispatch()

  const { isOpen, title, description, buttonText, isSuccess } = useSelector(
    (state: RootState) => state.globalNotificationModal
  )

  return (
    <SimpleModalDialog
      isOpen={isOpen}
      onClose={() => dispatch(hideGlobalModal())}
      success={isSuccess}
      title={title}
      description={description}
      buttonText={buttonText}
    />
  )
}
